import React, { useRef, useState, useEffect } from "react";
import { Row, Col, Table, Form } from "@themesberg/react-bootstrap";
import PaginationComponent from "../../../components/Pagination";
import Trigger from "../../../components/OverlayTrigger";
import useCategoryListing from "./useCategoryListing";
import ConfirmationModal from "../../../components/ConfirmationModal";
// import ConfirmationModal from '../../../components/ConfirmationModal'

import { DeleteConfirmationModal } from "../../../components/ConfirmationModal";
import CreateCasinoCategory from "./components/CreateCasinoCategory";
import { motion } from "framer-motion/dist/framer-motion";
import NotificationIconContainer from "../../../components/NotificationIcon/NotificationIconContainer";
import { CustomCol } from "./style";
import Preloader from "../../../components/Preloader";
import CasinoFilter from "./components/CasinoFilter";
import Toggle from "./components/Toggle";
import ActionMenu from "./ActionMenu";
import useCheckPermission from '../../../utils/checkPermission'
import CreateCasinoMenu from "./components/CreateUpdateCategory"
import { ToggleConfirmationModal } from "../../../components/ConfirmationModal"
import { AddButtonStyled, ButtonContainer, ResponsiveTitle } from './style'
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded'
import { toast } from "../../../components/Toast"
import useTableCustom from "../../../components/CusotmFilter"
import TableErrorMessage from "../../../components/TableErrorMessage"
import ImageModal from "../../../components/ImageModal";
import CategoryGamesModal from "./components/CategoryGamesModal"
import useCategoryGamesListing from "./useCategoryGames"
import { categoryTypeEnums } from "./constant"


const { REACT_APP_S3_URL } = process.env;



export default () => {
  const {
    status,
    name,
    show,
    statusShow,
    setStatusShow,
    limit,
    setLimit,
    page,
    setPage,
    loading,
    gameCategory,
    totalPages,
    search,
    handleYes,
    handleClose,
    setSearch,
    data,
    type,
    language,
    setLangauge,
    languages,
    createCategory,
    updateCategory,
    statusFilter,
    setStatusFilter,
    handleResetFilters,
    handleStatusShow,
    handleDeleteCategory,
    deleteCategory,
    setDeleteCatrgory,
    handleDeleteYes,
    handleShow,
    onHanldeStatusConfirmation,
    toggleStatus,
    onCancleToggleStatus,
    onToggleConfirmation,
    formikRef,
    onHandleCategory,
    setSelectedCategory,
    selectedCategory,
    casinocategoryType,
    navigateReorder,
    setImageModal,
    imageModal,
    categoryTypeFilter, setCategoryTypeFilter,
    totalCount
    // isShowActionCloumn
  } = useCategoryListing();

  const {
    showCasinoGamesModal,
    setShowCasinoGamesModal,
    // categoryGamesLimit,
    // setcategoryGameLimit,
    // categoryPage,
    // setCategoryPage,
    // gameCategoryId,
    // setCasinoGameId,
    categoryModalSelectedcategory,
    // setCategoryModalSelectedcategory,
    loadingCategorygames,
    categoryGamesData: games,
    hasMore,
    fetchNextPage,
    handleCloseGamesModal,
    onHandleDeleteCategoryGame
  } = useCategoryGamesListing()
  const { isHidden } = useCheckPermission()





  const isShowActionCloumn =
    !isHidden({ module: { key: 'CasinoCategory', value: 'U' } }) ||
    !isHidden({ module: { key: 'CasinoCategory', value: 'D' } });

  const isTogglePermission = !isHidden({
    module: { key: 'CasinoCategory', value: 'T' },
  });


  const isDeleteCategorygames = isHidden({
    module: {
      key: 'CasinoCategory',
      value: 'D',
    },
  })


  const headers = [
    { accessorKey: 'gameCategoryId', Header: 'gameCategoryId', value: 'id', label: 'Id' },
    { accessorKey: 'name', Header: 'name', value: 'Name', label: 'Name' },
    { accessorKey: 'gameLimit', Header: 'gameLimit', value: 'Game Limit', label: 'Game Limit' },
    { accessorKey: 'image', Header: 'Image', value: 'Image', label: 'Image' },
    { accessorKey: 'categoryType', Header: 'categoryType', value: 'Category type', label: 'Category type' },

  ];

  // Conditionally add "Status" column if user has toggle permission
  if (isTogglePermission) {
    headers.push({
      accessorKey: 'is_active',
      Header: 'is_active',
      value: 'status',
      label: 'Status',
    });
  }

  // Conditionally add "Actions" column if user has update or delete permission
  if (isShowActionCloumn) {
    headers.push({
      accessorKey: 'action',
      Header: 'Actions',
      value: 'action',
      label: 'Actions',
    });
  }


  const headerRef = useRef(null);
  const filterRef = useRef(null);
  const paginationRef = useRef(null);
  const [tableMaxHeight, setTableMaxHeight] = useState();

  const {
    visibleColumns,
    pageData,
    customColSetting,
    noDataFound,
  } = useTableCustom(
    gameCategory,
    headers, // already permission-filtered
    false,
    () => { },
    null,
    null,
    false,
    "",
    true,
    "CASINO_CATERGORIES_TABLE"
  );

  const visibleKeys = visibleColumns.map((col) => col.value);

  const filteredHeaders = headers.filter((header) =>
    visibleKeys.includes(header.value)
  );
  useEffect(() => {
    const updateMaxHeight = () => {
      const headerHeight = headerRef.current?.offsetHeight || 0;
      const filterHeight = filterRef.current?.offsetHeight || 0;
      const paginationHeight = paginationRef?.current?.offsetHeight || 0;

      const responsiveTable = document.querySelector('.table-responsive');
      const totalHeight = headerHeight + filterHeight + paginationHeight;
      const availableHeight = window.innerHeight - totalHeight - 130;

      if (window.innerWidth < 1000) {
        // For smaller screens: reset to full height
        if (responsiveTable) {
          responsiveTable.style.maxHeight = '100%';
          responsiveTable.style.overflowY = 'unset';
        }
        setTableMaxHeight('100%');
        return;
      }
      else if (responsiveTable) {
        responsiveTable.style.maxHeight = `${availableHeight}px`;
        responsiveTable.style.overflowY = 'auto'; // ensure scrolling
      }

      setTableMaxHeight(`${availableHeight}px`);
    };

    updateMaxHeight();
    window.addEventListener("resize", updateMaxHeight);
    return () => window.removeEventListener("resize", updateMaxHeight);
  }, []);
  console.log(gameCategory, "gameCategorygameCategory")
  return (
    <>
      <div className="section-header-wrap mt-n3 mx-n3" ref={headerRef}>
        <Row className="align-items-center justify-content-between">
          <Col xs={12} md={6}>
            <h2 className="title-text">Casino Categories </h2>
          </Col>
          {/* <Col lg={3} sm={12} className="">
            {isCreatePermission ? 
            <ButtonContainer className="d-flex justify-content-md-end">
              <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                className="flex-grow-1 flex-md-grow-0"
              >
                <AddButtonStyled
                  variant="primary"
                  onClick={() => {
                    handleShow("Create")
                  }}
                  hidden={isHidden({ module: { key: 'EmailTemplate', value: 'C' } })}
                >
                  <AddCircleOutlineRoundedIcon />
                  <span>Create Template</span>
                </AddButtonStyled>
              </motion.div>

            </ButtonContainer> : ""}
            <div className="ms-auto ms-md-2">
              <NotificationIconContainer />
            </div>
          </Col> */}

          <Col xs={12} md={6}>
            <ButtonContainer className="d-flex justify-content-md-end">
              <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                className="flex-grow-1 flex-md-grow-0"
              >
                <AddButtonStyled
                  variant="primary"
                  onClick={() => {
                    handleShow("Create")
                  }}
                  // onClick={() => navigate(AdminsRoutes.CreateStaff)}
                  hidden={isHidden({ module: { key: "CasinoCategory", value: "C" } })}
                >
                  <AddCircleOutlineRoundedIcon />
                  <span>Create Category</span>
                </AddButtonStyled>
              </motion.div>
              <div className="ms-auto ms-md-2">
                <NotificationIconContainer />
              </div>
            </ButtonContainer>
          </Col>

          <Col lg={4} sm={5}>
            <div className="d-flex justify-content-end">
              <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
              >
              </motion.div>
            </div>

          </Col>
        </Row>
      </div>
      <div ref={filterRef}>
        <CasinoFilter
          search={search}
          setSearch={setSearch}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
          setLimit={setLimit}
          setPage={setPage}
          handleResetFilters={handleResetFilters}
          customColSetting={customColSetting}
          navigateReorder={navigateReorder}
          categoryTypeFilter={categoryTypeFilter} setCategoryTypeFilter={setCategoryTypeFilter}
        />
      </div>
      {filteredHeaders.length === 0 ? (
        <TableErrorMessage />
      ) : (
        <div className="TableBg mt-4 p-0" >
          <div className="CustomTableWrapper">
            <div className="table-scroll-wrapper" style={{ maxHeight: tableMaxHeight }}>
              <div className="table-responsive">
                <Table
                  striped
                  hover
                  size="sm"
                  className="text-center mt-3"
                >
                  <thead className="thead-light">
                    <tr>
                      {filteredHeaders.map((header, idx) => (
                        <th key={idx}>{header?.label}</th>
                      ))}
                    </tr>
                  </thead>

                  {/* <tbody>
                  {!loading &&
                    gameCategory &&
                    gameCategory.length > 0 &&
                    gameCategory?.map(
                      ({ gameCategoryId, name, is_active }, index) => {
                        return (
                          <tr key={index}>
                            <td>{gameCategoryId}</td>
                            <td>
                              <Trigger message={name}>
                                <span
                                  style={{
                                    width: "100px",
                                    cursor: "pointer",
                                  }}
                                  className="d-inline-block text-truncate"
                                >
                                  {name}
                                </span>
                              </Trigger>
                            </td>

                            <td
                              style={{ color: status ? "green" : "red" }}
                            >
                              <Toggle
                                checked={is_active ? true : false}
                                onChange={() => isTogglePermission ? onHanldeStatusConfirmation({ gameCategoryId, name, is_active }) : toast("You don't have permission to change the status.", "error")}
                                align="left"
                                size="small"
                              />
                            </td>
                            {isShowActionCloumn && <td>
                              <ActionMenu isHidden={isHidden} index={index} gameCategory={gameCategory} gameCategoryId={gameCategoryId} name={name} isActive={is_active} handleShow={handleShow} handleStatusShow={handleStatusShow} handleDeleteCategory={handleDeleteCategory} />
                            </td>}
                          </tr>
                        );
                      }
                    )}

                  {loading ? (
                    <tr>
                      <td colSpan={4} className="p-0">
                        <div id="table-spinner" />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {!loading &&
                        (!gameCategory || gameCategory?.length === 0) && (
                          <tr>
                            <td colSpan={4} className="text-danger text-center">
                              No data found
                            </td>
                          </tr>
                        )}
                    </>
                  )}
                </tbody> */}

                  <tbody>
                    {!loading && gameCategory && gameCategory.length > 0 &&
                      gameCategory.map((row, index) => (
                        <tr key={index}>
                          {filteredHeaders.map((header, colIndex) => {
                            const key = header.accessorKey;
                            if (key === 'name') {
                              return (
                                <td key={colIndex}>
                                  <Trigger message={row.name}>
                                    <span
                                      style={{ width: "100px", cursor: "pointer" }}
                                      className="d-inline-block text-truncate"
                                    >
                                      {row.name}
                                    </span>
                                  </Trigger>
                                </td>
                              );
                            }

                            if (key === 'gameLimit') {
                              console.log(row, "row.gameLimit");
                              return (
                                <td key={colIndex}>
                                  {row?.categoryType === "vault" ? (
                                    <span style={{ width: "100px" }} className="d-inline-block text-truncate">
                                      N/A
                                    </span>
                                  ) : (
                                    <Trigger message={row.gameLimit}>
                                      <span
                                        style={{ width: "100px", cursor: "pointer" }}
                                        className="d-inline-block text-truncate"
                                      >
                                        {row.gameLimit || "N/A"}
                                      </span>
                                    </Trigger>
                                  )}
                                </td>
                              );
                            }

                            if (key === 'image') {
                              return (
                                <td key={colIndex}>
                                  {row.categoryImage ? <div message={row.name}>
                                    <img
                                      src={`${REACT_APP_S3_URL}/${row.categoryImage}`} //}` row.image} // or URL.createObjectURL(row.image) if it's a File object
                                      alt={row.categoryImage}
                                      style={{ width: '100px', height: 'auto', objectFit: 'contain', cursor: 'pointer' }}
                                      onClick={() => setImageModal({ isOpen: true, url: `${REACT_APP_S3_URL}/${row.categoryImage}` })}
                                    // onClick={() => window.open(`${REACT_APP_S3_URL}/${row.categoryImage}`, '_blank')}
                                    />
                                  </div> : "N/A"}
                                </td>
                              );
                            }


                            if (key === 'is_active') {
                              return (
                                <td key={colIndex} style={{ color: row.is_active ? "green" : "red" }}>
                                  <Toggle
                                    checked={row.is_active}
                                    onChange={() =>
                                      isTogglePermission
                                        ? onHanldeStatusConfirmation(row)
                                        : toast("You don't have permission to change the status.", "error")
                                    }
                                    align="left"
                                    size="small"
                                  />
                                </td>
                              );
                            }

                            if (key === 'categoryType') {
                              return (

                                <td key={colIndex}>
                                  {/* <Trigger message={row.name}> */}
                                  <span
                                  // style={{ width: "100px", cursor: "pointer" }}
                                  // className="d-inline-block text-truncate"
                                  >
                                    {row.categoryType === "featured" ? casinocategoryType?.featuredCategory : casinocategoryType?.vault}
                                  </span>
                                  {/* </Trigger> */}
                                </td>

                              );
                            }

                            if (key === 'action') {
                              return (
                                <td key={colIndex}>
                                  <ActionMenu
                                    isHidden={isHidden}
                                    index={index}
                                    gameCategory={gameCategory}
                                    gameCategoryId={row.gameCategoryId}
                                    categoryType={row.categoryType}
                                    categoryEnumn={casinocategoryType}
                                    name={row.name}
                                    isActive={row.is_active}
                                    categoryData={row}
                                    handleShow={handleShow}
                                    handleStatusShow={handleStatusShow}
                                    handleDeleteCategory={handleDeleteCategory}
                                    onHandleCategory={onHandleCategory}
                                    handleViewGames={setShowCasinoGamesModal}
                                    isCategoryValut={row.categoryType === categoryTypeEnums?.vault}
                                  />
                                </td>
                              );
                            }

                            // default fallback
                            return <td key={colIndex}>{row[key]}</td>;
                          })}
                        </tr>
                      ))
                    }

                    {loading ? (
                      <tr>
                        <td colSpan={filteredHeaders.length} className="p-0">
                          <div id="table-spinner" />
                        </td>
                      </tr>
                    ) : (
                      !gameCategory?.length && (
                        <tr>
                          <td colSpan={filteredHeaders.length} className="text-danger text-center">
                            No data found
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>


                </Table>
              </div>
            </div></div>
          {!loading && gameCategory && gameCategory.length > 0 && (
            <PaginationComponent
              page={gameCategory?.count < page ? setPage(1) : page}
              totalPages={totalPages}
              setPage={setPage}
              limit={limit}
              setLimit={setLimit}

              showTotalCount={true}
              totalCount={totalCount}
              countText={"Total Casino Categorys: "}

            />
          )}
        </div>)}

      {/* confirmation */}


      <ConfirmationModal
        setShow={setSelectedCategory}
        show={selectedCategory?.isOpen}
        handleYes={handleYes}
        active={status}
        title="Are you sure"
        subTitle={`Are you sure you want to  update the ${selectedCategory?.category?.name} Category from ${selectedCategory?.category?.
          categoryData
          ?.categoryType === "featured" ? casinocategoryType?.featuredCategory : casinocategoryType?.vault} to ${selectedCategory?.category?.
            categoryData
            ?.categoryType === "featured" ? casinocategoryType?.vault : casinocategoryType?.featuredCategory} `}
        undoneMessage="This action cannot be undone."
      />
      {deleteCategory?.isOpen ? <DeleteConfirmationModal deleteModalShow={true}
        setDeleteModalShow={() => setDeleteCatrgory({
          isOpen: false,
          id: "",
          status: "",
          name: "",
        })}
        handleDeleteYes={handleDeleteYes}
        name={`${deleteCategory?.name} Category`} /> : ""}

      {toggleStatus?.isOpen && <ToggleConfirmationModal showConfirmModal={toggleStatus?.isOpen} cancelStatusChange={onCancleToggleStatus} pendingStatusChange={toggleStatus?.status} confirmStatusChange={onToggleConfirmation} moduleName={"Casino Category"} message={toggleStatus?.name} />
      }
      <CreateCasinoMenu handleClose={handleClose}
        data={data}
        show={show}
        type={type}
        loading={loading}
        createProvider={createCategory}
        updateProvider={updateCategory}
        formikRef={formikRef}
      />

      <ImageModal show={imageModal?.isOpen} setShow={() => setImageModal({ isOpen: false, url: "" })} imageUrl={imageModal?.url} altText="Preview" />

      <CategoryGamesModal
        show={showCasinoGamesModal}
        games={games}
        hasMore={hasMore}
        onFetchMore={fetchNextPage}
        onClose={handleCloseGamesModal}
        loading={loadingCategorygames}
        title={categoryModalSelectedcategory?.name || 'Casino Games'}
        category={categoryModalSelectedcategory}
        onHandleDeleteCategoryGame={onHandleDeleteCategoryGame}
        isDeletePermission={isDeleteCategorygames}
      />
    </>

  );
};
